import { render, staticRenderFns } from "./IconSvgBothMessage.vue?vue&type=template&id=79caedb2&scoped=true&"
import script from "./IconSvgBothMessage.vue?vue&type=script&lang=js&"
export * from "./IconSvgBothMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79caedb2",
  null
  
)

export default component.exports